import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { t } from "i18next";
import Modifiers from "./ModifiersList";
import { getModifierDumbObj } from "utils/Utils";
import CartAction from "store/checkout/cart/cartSlice";

//TODO: Remove this after the new UI is implemented for delivery and pickup
const OldUI = ({
  modifierGroup,
  requiredMissing,
  baseLanguage,
  maximumAllowedSelection,
  minimumAllowedSelection,
  children,
}) => {
  return (
    <div className="pt-2 border-b-8 border-slate-100">
      <div className="p-4">
        <div className="flex">
          <div className="w-full pb-2" id={modifierGroup?._id}>
            <p className="text-outer-space text-16x font-bold leading-19x">
              {baseLanguage?.name}
            </p>
            {requiredMissing ? (
              <p className="text-14x  leading-19x pt-2 text-red-600">
                {t("choose upto", {
                  maximumAllowedSelection: maximumAllowedSelection,
                })}
              </p>
            ) : (
              <p className="text-14x text-gunsmoke leading-19x pt-2">
                {t("choose upto", {
                  maximumAllowedSelection: maximumAllowedSelection,
                })}
              </p>
            )}
          </div>
          <div className="px-2">
            {requiredMissing
              ? minimumAllowedSelection > 0 && (
                  <p className="font-bold   text-14x  leading-19x border border-red-500 text-red-500 px-2">
                    {t("Required")}
                  </p>
                )
              : minimumAllowedSelection > 0 && (
                  <p className="text-14x text-gunsmoke leading-19x  font-bold pt-2 ">
                    {t("Required")}
                  </p>
                )}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

const option = {
  required: {
    name: "Required",
    styleClass: "bg-danger-200 text-danger-800",
  },
  optional: {
    name: "Optional",
    styleClass: "bg-gray-200 text-gray-600",
  },
};

const getCurrentSelectionCount = (section) => {
  return section?.options?.reduce(
    (total, item) => total + (item?.quantity || 0),
    0
  );
};

const NewUI = ({
  modifierGroup,
  requiredMissing,
  baseLanguage,
  maximumAllowedSelection,
  minimumAllowedSelection,
  currentSelectionStatus,
  children,
}) => {
  const tag = minimumAllowedSelection > 0 ? option.required : option.optional;

  return (
    <div className="flex flex-col gap-2 relative">
      <div className="flex flex-col gap-2 sticky top-0 bg-white z-10 py-2">
        <div className="flex justify-between items-center capitalize ">
          <h2 className="text-dark-blue-900 text-20x font-bold m-0">
            {t(baseLanguage?.name)}
          </h2>
          <span className={`${tag?.styleClass} px-2 rounded-4x text-11x `}>
            {t(tag?.name)}
          </span>
        </div>
        {currentSelectionStatus?.isMaxSelectionReached && (
          <p className="text-14x text-red-600">
            {t("Maximum available quantity reached for {{name}}", {
              name: baseLanguage?.name,
            })}
          </p>
        )}
        <p
          className={`text-14x leading-19x ${
           requiredMissing
              ? "text-red-600"
              : "text-gunsmoke "
          }`}
        >
          {t("{{count}} selected — up to {{maximumAllowedSelection}} allowed", {
            count: currentSelectionStatus?.currentSelectionCount,
            maximumAllowedSelection: maximumAllowedSelection,
          })}
        </p>
      </div>
      {children}
    </div>
  );
};

const SingleModifierGroup = ({
  modifierGroup,
  setModifierGroups,
  selectedModifierGroups,
  setSingleItem,
  isStoreSelected,
  actualItemPrice,
  isNewUI,
  disable,
}) => {
  const { requiredMissingSections } = useSelector((state) => state?.NotPersist);
  const {
    maximumAllowedSelection,
    baseLanguage,
    minimumAllowedSelection,
    isSingleSelection,
  } = modifierGroup;
  const dispatch = useDispatch();

  const getMaxSelectionStatus = (section) => {
    const currentSelectionCount = getCurrentSelectionCount(section);
    const isMaxSelectionReached =
      currentSelectionCount >= maximumAllowedSelection;
    return {
      isMaxSelectionReached,
      currentSelectionCount,
    };
  };

  const currentSelectionStatus = useMemo(() => {
    const section = selectedModifierGroups.find((item) => item?._id === modifierGroup?._id);
    return {...getMaxSelectionStatus(section)};
  }, [selectedModifierGroups, modifierGroup]);

  useEffect(() => {
    if (requiredMissingSections?.length > 0) {
      const section = requiredMissingSections?.[0]?.modifierGroupId;
      if (section?._id) {
        const optionId = document.getElementById(section._id);
        optionId?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [requiredMissingSections, modifierGroup]);

  const handleReset = (item, secId) => {
    if (isSingleSelection === false) {
      checkboxClick(item, secId);
    } else radioButtonClick(item, secId);
  };

  // Adding And removing section options on checkBox click
  const checkboxClick = (item, secId) => {
    const newItems = [...selectedModifierGroups];
    // check if clicked  option section is already added
    const check = !!selectedModifierGroups?.find((i) => i?._id === secId);
    if (check) {
      // find section
      const section = selectedModifierGroups?.find((i) => i?._id === secId);
      const { isMaxSelectionReached } = getMaxSelectionStatus(section);
      // find index of option selected
      const index = section?.options?.findIndex((i) => i?._id === item?._id);
      //  if option already added then remove it
      if (index !== -1) {
        //get clicked option
        const selectedOption = section?.options[index];
        //remove clicked option
        section?.options?.splice(index, 1);
        //if this was last option-- remove the section as well
        if (section?.options?.length === 0) {
          const index = newItems?.findIndex((i) => i?._id === section?._id);
          newItems?.splice(index, 1);
        }
        setSingleItem((prevState) => ({
          ...prevState,
          price: prevState?.price - item.price * selectedOption?.quantity,
        }));
      }

      // else add the option in section
      else if (index === -1 && !isMaxSelectionReached) {
        setSingleItem((prevState) => ({
          ...prevState,
          price: prevState?.price + item.price,
        }));

        let Option = { ...item, quantity: 1 };
        const dumbOptObj = getModifierDumbObj(Option);
        section?.options.push({
          ...dumbOptObj,
        });
      } else if (isMaxSelectionReached) {
        dispatch(
          CartAction.setCartError(
            t("Maximum available quantity reached for {{name}}", {
              name: section?.baseLanguage?.name,
            })
          )
        );
        // return;
      }
    }

    // if this is the first option to be added update single item price and add new section in the cart
    else {
      let Option = { ...item, quantity: 1 };
      const dumbOptObj = getModifierDumbObj(Option);
      setSingleItem((prevState) => ({
        ...prevState,
        price: prevState.price + item?.price,
      }));
      newItems.push({
        baseLanguage: {
          sectionName: baseLanguage?.name,
        },
        _id: secId,
        options: [dumbOptObj],
        isSingleSelection: isSingleSelection,
        minimumAllowedSelection: minimumAllowedSelection,
        maximumAllowedSelection: maximumAllowedSelection,
        numOfSelectedOptions: 1,
      });
    }
    setModifierGroups(newItems);
  };

  //Check-Box Quantity change
  const QuantityChange = (item, secId, action, isNewUI = false) => {
    if (disable) return;
    const newItems = [...selectedModifierGroups];
    // Check if the clicked option section is already added
    const sectionIndex = newItems?.findIndex((i) => i?._id === secId);

    if (sectionIndex !== -1) {
      // The section is already added
      const section = newItems[sectionIndex];
      const { isMaxSelectionReached } = getMaxSelectionStatus(section);
      const optionIndex = section?.options?.findIndex(
        (i) => i?._id === item?._id
      );

      if (optionIndex !== -1) {
        // The option is already added to the section
        if (action === "increment") {
          // Increment the quantity
          section.options[optionIndex].quantity += 1;
          // Check stock limit before incrementing
          if (
            item.isStockEnabled &&
            section.options[optionIndex].quantity >= item.availableStock
          ) {
            dispatch(
              CartAction.setCartError("Maximum available quantity reached")
            );
            return;
          }
          setSingleItem((prevState) => ({
            ...prevState,
            price: prevState?.price + item.price,
          }));
        } else if (action === "decrement") {
          // Decrement the quantity

          const safeValue = isNewUI ? 0 : 1;
          if (section.options[optionIndex]?.quantity > safeValue) {
            section.options[optionIndex].quantity -= 1;
            // if qunatity is set to zero, then we have to rest this from selection as well.
            if (section.options?.[optionIndex]?.quantity <= 0) {
              handleReset(item, secId);
            }
            setSingleItem((prevState) => ({
              ...prevState,
              price: prevState.price - item?.price,
            }));
          } else if (isNewUI) {
            handleReset(item, secId);
          }
        }
      } else if (!isMaxSelectionReached && action === "increment") {
        const option = {
          ...item,
          quantity: 1,
        };
        const dumbOptObj = getModifierDumbObj(option);
        // Add the option to the section with quantity 1
        section.options.push(dumbOptObj);
        setSingleItem((prevState) => ({
          ...prevState,
          price: prevState.price + item?.price,
        }));
      } else if (isMaxSelectionReached) {
        dispatch(
          CartAction.setCartError(
            t("Maximum available quantity reached for {{name}}", {
              name: section?.baseLanguage?.name,
            })
          )
        );
        return;
      }
      // to auto set the new, items, for single selction, this condition will reset all previous modifes to null, and add current modifier to item
      else if (
        (isSingleSelection || maximumAllowedSelection <= 1) &&
        optionIndex === -1 &&
        action === "increment"
      ) {
        const option = {
          ...item,
          quantity: 1,
        };
        const dumbOptObj = getModifierDumbObj(option);
        // Add the option to the section with quantity 1
        section.options = [dumbOptObj];
        setSingleItem((prevState) => ({
          ...prevState,
          quantity: 1,
          price: actualItemPrice + item?.price,
        }));
      }
    }
    //New section
    else {
      // The section is not added yet
      if (action === "increment") {
        // Create a new section with the option and quantity 1
        let option = { ...item, quantity: 1 };
        const dumbOptObj = getModifierDumbObj(option);
        newItems.push({
          baseLanguage: {
            sectionName: baseLanguage.name,
          },
          _id: secId,
          options: [dumbOptObj],
          isSingleSelection: isSingleSelection,
          minimumAllowedSelection: minimumAllowedSelection,
          maximumAllowedSelection: maximumAllowedSelection,
        });
        setSingleItem((prevState) => ({
          ...prevState,
          price: prevState.price + item?.price,
        }));
      }
    }

    setModifierGroups(newItems);
  };

  //Radio Button
  const radioButtonClick = (item, secId) => {
    if (disable) return;
    const dumbOptObj = getModifierDumbObj({ ...item, quantity: 1 });
    const obj = {
      baseLanguage: {
        sectionName: baseLanguage.name,
      },
      _id: secId,
      options: [dumbOptObj],
      isSingleSelection: isSingleSelection,
      minimumAllowedSelection: minimumAllowedSelection,
      maximumAllowedSelection: maximumAllowedSelection,
    };
    var newItemss = [...selectedModifierGroups];

    //check if same section is added already
    const check = !!selectedModifierGroups?.find((i) => i?._id === secId);
    if (check) {
      //find the selected section
      const deleted = selectedModifierGroups?.find((i) => i?._id === secId);
      //find the index of section
      const index = newItemss?.findIndex((i) => i?._id === deleted?._id);

      //find the option at zero loc Price  (single selection can have only one selected option)
      const deletedItemPrice =
        deleted?.options?.length > 0 ? deleted?.options[0]?.price : 0;

      const addedOption = deleted?.options[0];
      //remove price of selected  option

      //if its same option --> then un-uncheck and subtract price
      if (item?._id === addedOption?._id) {
        setSingleItem((prevState) => ({
          ...prevState,
          price: prevState?.price - deletedItemPrice * addedOption?.quantity,
        }));

        newItemss.splice(index, 1);
      } else {
        //if its differnt option subtract selected Price with quantity and update new price
        setSingleItem((prevState) => ({
          ...prevState,
          price:
            prevState?.price +
            item?.price -
            deletedItemPrice * addedOption.quantity,
        }));
        //remove the section with Price
        newItemss?.splice(index, 1);
        //add same section  entry with new option
        newItemss?.push(obj);
      }
    }
    //if section is not there
    else {
      newItemss.push(obj);
      setSingleItem((prevState) => ({
        ...prevState,
        price: prevState.price + item.price,
      }));
    }
    setModifierGroups(newItemss);
  };

  const updateRadioQuantity = (item, secId, action, isNewUI) => {
    if (disable) return;
    const newItems = [...selectedModifierGroups];

    // Check if the clicked option section is already added
    const sectionIndex = newItems?.findIndex((i) => i?._id === secId);

    if (sectionIndex !== -1) {
      // The section is already added
      const section = newItems[sectionIndex];
      const selectedOption = section?.options[0];

      //check if differnt option action is fired
      if (selectedOption?._id !== item?._id) {
        if (action === "increment") {
          // Remove the previously selected option and add the new one
          setSingleItem((prevState) => ({
            ...prevState,
            price:
              (prevState?.price || 0) -
              (selectedOption?.price || 0) * selectedOption?.quantity +
              item?.price,
          }));
          section?.options?.pop(); // Remove the previously selected option

          // Create a new section with the new option and quantity 1
          const newOption = { ...item, quantity: 1 };
          const dumbOptObj = getModifierDumbObj(newOption);
          section?.options?.push(dumbOptObj);
        } else {
        }
      } else {
        if (action === "increment") {
          // Check if the action is "increment" or "decrement"

          // Increment the quantity
          selectedOption.quantity += 1;
          setSingleItem((prevState) => ({
            ...prevState,
            price: prevState.price + item.price,
          }));
        } else if (action === "decrement") {
          const safeValue = isNewUI ? 0 : 1;
          // Decrement the quantity if it's greater than 1
          if (selectedOption.quantity > safeValue) {
            selectedOption.quantity -= 1;
            setSingleItem((prevState) => ({
              ...prevState,
              price: prevState.price - item?.price,
            }));
          }
        }
      }
    } else {
      // The section is not added yet
      if (action === "increment") {
        // Create a new section with the option and quantity 1
        let newOption = { ...item, quantity: 1 };
        const dumbOptObj = getModifierDumbObj(newOption);
        newItems.push({
          baseLanguage: {
            sectionName: baseLanguage.name,
          },
          _id: secId,
          options: [dumbOptObj],
          isSingleSelection: isSingleSelection,
          minimumAllowedSelection: minimumAllowedSelection,
          maximumAllowedSelection: 1, // Set maximumAllowedSelection to 1 for radio buttons
        });
        setSingleItem((prevState) => ({
          ...prevState,
          price: prevState?.price + item?.price,
        }));
      }
    }

    setModifierGroups(newItems);
  };

  const requiredMissing = useMemo(() => {
    return requiredMissingSections?.find(
      (option) => option?.modifierGroupId?._id === modifierGroup?._id
    );
  }, [requiredMissingSections, modifierGroup]);

 

  //increase decrease

  const Tag = isNewUI ? NewUI : OldUI;
  return (
    <Tag
      modifierGroup={modifierGroup}
      requiredMissing={requiredMissing}
      baseLanguage={baseLanguage}
      maximumAllowedSelection={maximumAllowedSelection}
      minimumAllowedSelection={minimumAllowedSelection}
      disable={disable}
      currentSelectionStatus={currentSelectionStatus}

    >
      <Modifiers
        isStoreSelected={isStoreSelected}
        isNewUI={isNewUI}
        {...{
          modifierGroup,
          selectedModifierGroups,
          radioButtonClick,
          checkboxClick,
          QuantityChange,
          updateRadioQuantity,
        }}
        disable={disable}
        isMaxSelectionReached={currentSelectionStatus?.isMaxSelectionReached}
      />
    </Tag>
  );
};

export default SingleModifierGroup;
